export default "__VITE_ASSET__uylQYohx__"